import React, { useEffect, useState } from "react"
import { useShallow } from "zustand/react/shallow"

// // components
import Modal from "components/Modal/Modal"
import { TextInput } from "components-design-system"
import { PrimeButton } from "components-design-system"
import CharCounter from "components/CharCounter/CharCounter"
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

import "./CommentModal.scss"

const CommentModal = ({ openModal, setOpenModal, saveComment, selectedComment }) => {
  const [comment, setComment] = useState("")

  const { formView, readOnly } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
      readOnly: state.readOnly,
    }))
  )

  useEffect(() => {
    if (selectedComment) {
      setComment(selectedComment)
    }
  }, [selectedComment])

  return (
    <Modal
      title={`Add/Edit Comment`}
      open={openModal}
      onCancel={() => setOpenModal(false)}
      footer={[]}
      hideImage={true}
    >
      <div className="pf-prs-comment-modal-content">
        <TextInput
          type="textarea"
          placeholder="Enter comment"
          value={comment || ""}
          onChange={(e) => setComment(e.target.value)}
          autoSize={{ minRows: 3 }}
          style={{ width: "100%" }}
        />
        {formView !== "global" && !readOnly && (
          <CharCounter
            value={comment}
            maxChars={500}
          />
        )}
      </div>
      <div className="comment-action-container">
        <PrimeButton onClick={() => setOpenModal(false)}>Cancel</PrimeButton>
        <PrimeButton
          type="primary"
          onClick={() => {
            saveComment(comment)
            setOpenModal(false)
          }}
        >
          Save Comment
        </PrimeButton>
      </div>
    </Modal>
  )
}

export default CommentModal
